module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_sns_06-2279ecbbdfc65e2c6a91927e91d94a2e.jpg";